import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class ReprocessamentoService {

    private _config: Config = new Config();

    constructor(private http: HttpClient) { }

    public reprocessar(filtros: object = null): Observable<any>  {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/reprocessar`, filtros);
    }

}
